import Vue from 'vue'
import Router from 'vue-router'

// routes
import Login from '@/pages/login/routes.login'
import Dashboard from '@/pages/dashboard/routes.dashboard'
import Prizing from '@/pages/prizing/routes.prizing'
import Tiers from '@/pages/tiers/routes.tiers'
import TierPrizes from '@/pages/tier-prize/routes.tier_prize'
import Prize from '@/pages/prize/routes.prize'
import SkillTestingQuestions from '@/pages/skill-tesing-question/routes.skill_testing'

/* Global Components */
/* -----Offset Heading----- */
import OffsetHeading from '@/components/custom-components/OffsetHeading'
Vue.component('offset-heading', OffsetHeading)
Vue.component('offset-block', () =>
  import('@/components/custom-components/OffsetBlock')
)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...Login,
    ...Dashboard,
    ...Prizing,
    ...Tiers,
    ...Prize,
    ...TierPrizes,
    ...SkillTestingQuestions
  ]
})

export default router
